<template>
    <div style="height:100%">
        <Button class="add-btn" type="primary" v-if="editState" @click="addPreservation">新增保全</Button>
        
        <!-- 列表 -->
        <Row class="table-box">
            <Table :columns="columns" :loading="tableLoading" :data="data">
                <template slot-scope="{ row, index }" slot="checkFile" v-if="row.attachmentList.length>0">
                    <Dropdown>
                        <a href="javascript:void(0)">
                            更多材料
                            <Icon type="ios-arrow-down" size="16"/>
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem v-for="item in row.attachmentList" :key="item.id">
                                <a :href="item.url" :download="item.fileName" target="_blank">{{item.fileName}}</a>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </template>
            </Table>
        </Row>
        <!-- 保全modal -->
        <Modal
            v-model="addCtrl"
            :title="title"
            :width="450"
            :footer-hide="true">
            <Form ref="formValidate" v-if="addCtrl" :model="formValidate" :rules="ruleValidate" :label-width="100" style="height:100%">
                <FormItem label="申请人" prop="applicant">
                    <Input v-model="formValidate.applicant" placeholder="请选择申请人"></Input>
                </FormItem>
                <FormItem label="被申请人" prop="respondent">
                    <Input v-model="formValidate.respondent" placeholder="请选择被申请人"></Input>
                </FormItem>
                <FormItem label="保全类型" prop="preservationType">
                    <Select v-model="formValidate.preservationType" placeholder="请选择保全类型">
                        <Option v-for="item in preservationTypeArr" :value="item.value" :key="item.id">{{item.nameZh}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="保全金额" prop="amount" v-if="formValidate.preservationType==='P'"
                    :rules="[{ required: true, message: '保全金额不能为空', trigger: 'blur' },{validator:overMillion, trigger: 'blur'}]">
                    <my-input
                        appendText="￥" 
                        :defaultData="formValidate.amount"
                        :toFixed="2"
                        @getValue="getInputValue($event,'amount')"
                    ></my-input>
                </FormItem>
                <FormItem label="保全材料附件" prop="attachmentList">
                    <file-upload
                        :defaultList="defaultList || []" 
                        :uploadConfig="uploadConfig"
                        @getFileList="getAttachmentList"></file-upload>
                </FormItem>
                <Row class="detail-btn-box">
                    <Button type="primary" style="margin-right:10px;" :disabled="isSubmit" @click="submit">保存</Button>
                    <Button @click="addCtrl=false">取消</Button>
                </Row>
            </Form>
        </Modal>

        <Modal
            v-model="materialCtrl"
            title="查看保全材料"
            :width="450"
            :footer-hide="true">
            <Row class="detail-content" v-if="materialCtrl">
                <Row>
                    <Col span="5" class="left-label">保全材料：</Col>
                    <Col span="16" class="right-content">
                        <file-upload
                            :defaultList="materialAttchment || []" 
                            :uploadConfig="{readOnly:true}"></file-upload>
                    </Col>
                </Row>
            </Row>
        </Modal>
    </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss';
export default {
    data () {
        const overMillion = (rule, value, callback) => {
            if(Number(value)>100000000){
                return callback(new Error('金额不能超过一亿'));
            }
            callback();
        };
        return {
            styles:styles,
            overMillion:overMillion,
            preservationTypeArr:[],
            formValidate:{
                applicant:'',
                respondent:'',
                preservationType:'P',
                amount:'',
                attachmentList:[]
            },
            ruleValidate:{
                applicant:[
                    { required: true, message: '申请人不能为空', trigger: 'change' },
                    { max:32, message:'长度不能超过32个字符', trigger:'blur'}
                ],
                respondent:[
                    { required: true, message: '被申请人不能为空', trigger: 'change' },
                    { max:32, message:'长度不能超过32个字符', trigger:'blur'}
                ],
                preservationType:[{ required: true, message: '保全类型不能为空', trigger: 'change' }],
            },
            uploadConfig:{
                fileName:'',
            },
            editId:'',
            defaultList:[],
            isSubmit:false,
            tableLoading:false,
            data:[],
            title:'',
            materialCtrl:false,
            materialAttchment:"",
            columns:[
                {
                    title:"保全类型",
                    key:"preservationTypeName",
                },
                {
                    title:"申请人",
                    key:"applicant",
                },
                {
                    title:"被申请人",
                    key:"respondent",
                },
                {
                    title:"保全金额",
                    key:"amount",
                    render:(h,params)=>{
                        return h('span',this.common.formateNumber(params.row.amount))
                    }
                },
                {
                    title:"保全材料",
                    key:"attachmentList",
                    slot:'checkFile'
                },
                {
                    title:"操作",
                    key:"action",
                    render:(h,params)=>{
                        let dom = h("span",{
                            class:["icon-edit-01"],
                            attrs:{
                                title:"修改信息",
                            },
                            style:{
                                cursor:"pointer"
                            },
                            on:{
                                click:()=>{
                                    this.title = '修改保全信息'
                                    this.addCtrl = true;
                                    this.getDetail(params.row)
                                }
                            }
                        });
                        return this.editState?dom:[]
                    }
                },
            ],
            addCtrl:false,
        }
    },
    props: ['processId','caseId','editState'],
    methods: {
        getInputValue(data,name){
            this.formValidate[name] = data;
        },
        //获取图片列表
        getAttachmentList (arr) {
            this.formValidate.attachmentList = [];
            arr.forEach((item,index)=>{
                let obj = {
                    fileName:item.fileName,
                    mediaType:item.mediaType,
                    smallUrl:item.smallUrl,
                    url:item.url
                }
                this.formValidate.attachmentList.push(obj);
            })
        },
        addPreservation(){
            this.addCtrl = true;
            this.title = '新增保全'
            this.formValidate = {
                applicant:'',
                respondent:'',
                preservationType:'P',
                amount:'',
                attachmentList:[]
            }
        },
        submit(){
            this.$refs['formValidate'].validate((vaild)=>{
                if(vaild){
                    this.isSubmit = true;
                    let url = '/business/case/preservation';
                    let ajaxData = {};
                    Object.assign(ajaxData,this.formValidate);
                    ajaxData.processId = this.processId;
                    ajaxData.caseId = this.caseId;
                    ajaxData.amount = ajaxData.preservationType==='E'?'':ajaxData.amount;
                    if(this.editId){
                        ajaxData.id = this.editId;
                        this.$patch(url,ajaxData).then(res=>{
                            if(res.code===0){
                                this.$Message.success('操作成功')
                                this.$emit('reloadProcess');
                            }else{
                                this.$Message.error(res.message)
                            }
                            this.isSubmit = false;
                            this.getData();
                        })
                    }else{
                        this.$post(url,ajaxData).then(res=>{
                            if(res.code===0){
                                this.$Message.success('操作成功')
                                this.$emit('reloadProcess');
                            }else{
                                this.$Message.error(res.message)
                            }
                            this.isSubmit = false;
                            this.getData();
                        })
                    }
                }
            })
        },
        getData(type){
            let url = '/business/case/preservation/'+this.processId;
            this.$get(url).then(res=>{
                if(res.code===0&&res.data){
                    this.data = res.data;
                    this.addCtrl = type=='edit'?true:false;
                    if(type=='edit'){
                        this.getDetail(this.summonsInfo);
                    }
                }else{
                    this.addCtrl = false;
                }
            })
        },
        getDetail(value){
            let data = JSON.parse(JSON.stringify(value))
            this.editId = data.id;
            for(let key in this.formValidate){
                this.formValidate[key] = data[key]
            }
            this.defaultList = data.attachmentList.length>0?data.attachmentList.map(item=>{
                return {
                    fileName:item.fileName,
                    mediaType:item.mediaType,
                    smallUrl:item.smallUrl,
                    url:item.url
                }
            }):[];
            this.formValidate.attachmentList = this.defaultList;
        },
        //获取字典数据接口
        async getDictionary(){
            this.preservationTypeArr = await this.common.getDictionaryItems('preservation_type');
        },
    },
    created(){},
    beforeMount(){
        this.getDictionary()
        this.getData();
    },
    mounted(){},
    updated(){},
    components: {},
    watch: {}
}
</script>
<style scoped lang="scss">
@import '../caseCommon.scss';
.add-btn{
    margin-top:-64px;
}
.table-box{
    margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/pretrial/preservation.vue